import { getBreadcrumbsData } from '@fttb/common/store';
import { createSelector } from '@reduxjs/toolkit';
import { createMergedBlockSelector } from "../../selectors";
import { getHeadingBlock } from "../selectors";
var getHeadingData = createMergedBlockSelector(getHeadingBlock);
export var getHeadingTitle = function getHeadingTitle(state) {
  return getHeadingData(state).title;
};
export var getTitleImgUrl = function getTitleImgUrl(state) {
  return getHeadingData(state).imgUrl;
};
export var getHeadingBackgroundColor = function getHeadingBackgroundColor(state) {
  return getHeadingData(state).bgColor;
};
export var getTitleColor = function getTitleColor(state) {
  return getHeadingData(state).titleColor;
};
export var getIsDivider = function getIsDivider(state) {
  return getHeadingData(state).withDivider;
};
export var getTextColor = function getTextColor(state) {
  return getHeadingData(state).textColor;
};
export var getVariant = function getVariant(state) {
  return getHeadingData(state).variant;
};
export var getHeadingBannerText = function getHeadingBannerText(state) {
  return getHeadingData(state).text;
};
export var getHeadingBannerButtonText = function getHeadingBannerButtonText(state) {
  return getHeadingData(state).buttonText;
};
export var getHeadingBannerButtonLink = function getHeadingBannerButtonLink(state) {
  return getHeadingData(state).link;
};
export var getIsHiddenBreadcrumbs = function getIsHiddenBreadcrumbs(state) {
  return getHeadingData(state).isHiddenBreadcrumbs;
};

// @ts-expect-error fixme later
export var getIsRenderBreadcrumbs = createSelector([getBreadcrumbsData, getIsHiddenBreadcrumbs], function (data, flagIsHidden) {
  return !flagIsHidden && !!data;
});